import "../styles/MenuPage.css"
import {getIcon} from "../utils/helper";
import React from 'react';
import MenuComponent from "../components/menu";

export const MenuPage = () => {
    return <div className={"container-home"}>

        <div className={"container"}>
            <div className="section menu bg-black-10 text-center ">
                <div className="content-header">
                    <p className="label-2 section-subtitle slider-reveal">{"Speisekarte"}</p>
                    <div className="icon-separator">
                        {getIcon("separator")}
                    </div>

                </div>
                <div className="content-menu">
                    <div className="menu-food">
                        <MenuComponent />
                    </div>

                </div>
                <p className="menu-text text-center">
                    Im Winter täglich von <span className="strong">11.30Uhr</span> bis <span className="strong">22.00Uhr</span>
                </p>
                <img src="/assets/images/shape-6.png" loading="lazy" alt="shape"
                     className="shape shape-2 move-anim"/>
                <img src="/assets/images/shape-5.png" loading="lazy" alt="shape"
                     className="shape shape-1 move-anim"/>
            </div>
        </div>

    </div>
}